import React, { Component } from 'react';
import $ from 'jquery';
import { useParams } from 'react-router-dom';

class Boardview extends Component {
	constructor(props) {
    	super(props);

		this.state = {
			board: {}
		}
	}
	
	componentDidMount() {
		const { idx } = this.props.match.params;
		
		let fetchData = async () => {
			
            let url = `https://api.tfamily.co.kr/api/board/get`;
			let filter = {
				idx: idx
			};
			let uk = sessionStorage.getItem('loginKey');
			const self = this;
    		let params = { "uk" : uk, ...filter };
			$.get(url, params, function(data){
				let parsedJSON = JSON.parse(data);
				console.log(parsedJSON.data);
				self.setState({
					board: parsedJSON.data
				})
			});
        };
        fetchData();
	}
	
	render() {
		const { type } = this.props.match.params;
		const nameChange = (val) => {
			const arr = [...val];  // Convert string to array
			arr[1] = "*";          // Set char c at pos i
			return arr.join(''); // Back to string
		}
		return (<>
			<div className="board_title">
				<div className="board_notice_title" onClick={()=>{
					window.history.back();
					//window.location.href = "/";
				}}>
					<i className="fas fa-chevron-left" /> {type === "notice" ? "공지사항" : "이벤트" }
				</div>
				<br/>
				<div style={{padding:'6px 12px'}} className="min-board-height">
					<div className="text-title">{this.state.board.title}</div>
					<div style={{fontSize:'14px'}} className="text-title">{this.state.board.customer && this.state.board.customer.length === 0 ?  "관리자" : this.state.board.customer ? nameChange(this.state.board.customer[0].username) : "" }</div>
					<div className="text-right">{this.state.board ? this.state.board.created_at : null}</div>
					<hr/>
					<div dangerouslySetInnerHTML={{__html:this.state.board.contents}}>
					</div>
				</div>
			</div>
		</>);
	}
	
}

export default Boardview;